const SetDefaultTestsBySpecimenType = (contents, specimenType, mapValues, pageName) => {

    if (mapValues === undefined || mapValues === null || mapValues === "") {
        return;
    }

    const elementToChange = contents.findIndex((page) => { return page.Name === pageName})
    const mapping = mapValues.filter((map) => { return parseInt(specimenType,10) === map.SpecimenType})

    if (elementToChange > -1) {
        for (const itemToClear of contents[elementToChange].Contents) {
            itemToClear.Allowed = 'No';
        }
    }

    if (mapping.length > 0 && elementToChange > -1) {
        for (const item of mapping[0].Values) { 
            const itemToChange = contents[elementToChange].Contents.findIndex((i) => { return i.Key === item });
            if (itemToChange > -1) {
                contents[elementToChange].Contents[itemToChange].Allowed = "Yes";
            }
        }
    }
}

export default SetDefaultTestsBySpecimenType;